import React, { useState } from 'react';
import { FaCheck, FaTrash, FaTimes,FaRedo} from 'react-icons/fa';
import { Modal, Button } from 'react-bootstrap';
import EditTransactionModal from './_editmodal.tsx';
import RejectTransactionModal from './_reject_modal.jsx';

const TenantRow = ({ tenant, selected, onSelect, onApprove, onEdit, onDelete }) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showReapproveModal, setShowReapproveModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // Determine invoice status color and label
  let invoiceStatusClass = '';
  let invoiceStatusLabel = '';
  switch (tenant.invoice_status?.toLowerCase()) {
    case 'paid':
      invoiceStatusClass = 'bg-green-100 text-green-700';
      invoiceStatusLabel = 'Paid';
      break;
    case 'partial':
      invoiceStatusClass = 'bg-yellow-100 text-yellow-700';
      invoiceStatusLabel = 'Partial';
      break;
    case 'unpaid':
    default:
      invoiceStatusClass = 'bg-red-100 text-red-700';
      invoiceStatusLabel = 'Unpaid';
      break;
  }

  // Determine approval status color and label
  let approvalStatusClass = '';
  let approvalStatusLabel = tenant.approval_status || 'pending';
  switch (approvalStatusLabel.toLowerCase()) {
    case 'approved':
      approvalStatusClass = 'bg-green-100 text-green-700';
      break;
    case 'rejected':
      approvalStatusClass = 'bg-red-100 text-red-700';
      break;
    case 'pending':
    default:
      approvalStatusClass = 'bg-yellow-100 text-yellow-700';
      break;
  }

  const isApproved = tenant.approval_status === 'approved';
  const isPending = tenant.approval_status === 'pending';
  const isRejected = tenant.approval_status === 'rejected';

  const handleEdit = () => {
    setShowEditModal(true);
  };

  const handleSave = (editedData) => {
    onEdit(tenant.id, editedData);
    setShowEditModal(false);
  };


  const handleRejectSave = (tenant) => {
    // onEdit(tenant.id, editedData);
    setShowEditModal(false);
  };

  const handleReapprove = () => {
    setShowReapproveModal(true);
  };

  const confirmReapprove = () => {
    onApprove([tenant.id]);
    setShowReapproveModal(false);
  };

  const handleDelete = () => {
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    onDelete(tenant.id);
    setShowDeleteModal(false);
  };

  return (
    <>
      <tr className="hover:bg-gray-50 transition">
        <td className="px-4 py-3">
          {!isApproved && !isRejected && (
            <input
              type="checkbox"
              className="border-gray-300 rounded focus:ring-blue-500 text-blue-600 form-checkbox"
              checked={selected}
              onChange={() => onSelect(tenant.id)}
            />
          )}
          {isApproved && <FaCheck className="text-green-500" />}
          {isRejected && <FaTimes className="text-red-500" />}
        </td>
        <td className="px-4 py-3">{tenant.name}</td>
        <td className="px-4 py-3">
          <span className={`inline-block px-2 py-1 rounded text-xs font-medium ${approvalStatusClass}`}>
            {approvalStatusLabel}
          </span>
        </td>
        <td className="px-4 py-3">{tenant.phone_number}</td>
        <td className="px-4 py-3">
          <div className="flex flex-col">
            <span className="font-medium">{tenant.house_number}</span>
            <span className="text-gray-500 text-sm">{tenant.apartment}</span>
          </div>
        </td>

        <td className="px-4 py-3">
          KES.{Number(tenant?.paid_amount).toLocaleString('en-US')}
        </td>
        <td className="px-4 py-3">
          <div className='flex flex-col'>
            <span className="font-medium"> {tenant.transaction_id}</span>
            <span className="text-gray-500 text-sm"> {tenant.payment_method.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())}</span>
          </div>
        </td>
        {/* <td className="px-4 py-3">{tenant.payment_date}</td> */}
        <td className="px-4 py-3">
          {new Date(tenant.payment_date).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "long",
            year: "numeric"
          })}
        </td>
        <td className="flex gap-2 px-4 py-3">
          {isPending && (
            <button
              className="flex items-center gap-1 bg-blue-500 hover:bg-blue-600 px-3 py-1 rounded-md text-white text-xs transition"
              onClick={handleEdit}
            >
              Edit
            </button>
          )}
          {isApproved && (
            <button
              className="flex items-center gap-1 bg-yellow-500 hover:bg-yellow-600 px-3 py-1 rounded-md text-white text-xs transition"
              
               onClick={() => {
    console.log('🔍 Opening reject modal for tenant:', tenant);
    console.log('🔍 Tenant ID:', tenant.id);
    setShowRejectModal(true);
  }}
            >
              <FaRedo />
              Reject
            </button>
          )}


          {isRejected && (
            <>
              {/* <button
                className="flex items-center gap-1 bg-green-500 hover:bg-green-600 px-3 py-1 rounded-md text-white text-xs transition"
                onClick={handleReapprove}
                title="Reapprove"
              >
                <FaRedo />
              </button> */}
              <button
                className="flex items-center gap-1 bg-red-500 hover:bg-red-600 px-3 py-1 rounded-md text-white text-xs transition"
                onClick={handleDelete}
                title="Delete"
              >
                <FaTrash />
              </button>
            </>
          )}
        </td>
      </tr>

      {/* Edit Modal */}
      {showEditModal && (
        <EditTransactionModal
          tenant={tenant}
          onClose={() => setShowEditModal(false)}
          onSave={handleSave}
        />
      )}

      {/* Reject Modal */}
      {showRejectModal && (
        <RejectTransactionModal
          tenant={tenant}
          onClose={() => setShowRejectModal(false)}
          onSave={handleRejectSave}
        />
      )}



      {/* Reapprove Confirmation Modal */}
      <Modal
        show={showReapproveModal}
        onHide={() => setShowReapproveModal(false)}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton className="bg-green-600 text-white">
          <Modal.Title>Confirm Reapproval</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-5 text-center">

          <h5 className="mb-3 font-semibold text-gray-800">
            Reapprove This Payment?
          </h5>
          <p className="text-gray-600">
            This will mark the payment as approved and process the payment.
            <br />
            Are you sure you want to continue?
          </p>
        </Modal.Body>
        <Modal.Footer className="flex justify-between">
          <Button
            variant="secondary"
            onClick={() => setShowReapproveModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            onClick={confirmReapprove}
          >
            Reapprove
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton className="bg-red-600 text-white">
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-5 text-center">

          <h5 className="mb-3 font-semibold text-gray-800">
            Delete This Payment?
          </h5>
          <p className="text-gray-600">
            This action cannot be undone. The payment will be permanently deleted.
            <br />
            Are you sure you want to continue?
          </p>
        </Modal.Body>
        <Modal.Footer className="flex justify-between">
          <Button
            variant="secondary"
            onClick={() => setShowDeleteModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={confirmDelete}
          >
            Delete Permanently
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TenantRow;
